import { PinnedMarketsQueryKeys } from "@/tanstackQuery/queries/pinnedMarkets";
import { addPinnedMarket, deletePinnedMarket } from "@/api/pinnedMarkets";
import { useToggleMutation } from "../hooks";

// Optimistic add/remove of a pinned market group. The "entity" is just the
// group number, so getSelectionKey is identity. Mirrors useToggleFavoriteLeague.
export const useTogglePinnedMarket = () =>
  useToggleMutation<number>({
    queryKey: [PinnedMarketsQueryKeys.All],
    addMutationFn: addPinnedMarket,
    deleteMutationFn: deletePinnedMarket,
    getSelectionKey: (group) => group,
    updateOptions: { preventRefetchOnSettled: true }
  });
